import { ReactNode } from "react";
import { EntityType } from "../../Common.types";

export interface DocumentPreviewable {
    documentId: string;
    name: string;
    fileName?: string;
    link?: string;
    dataId?: string;
    documentVersionId?: string;
    entityId?: string;
    entityType?: EntityType;
    entityTitle?: string;
    isTooLargeForAi?: boolean;
}

interface BasePreviewableDocument {
    documentId: string;
    dataId?: string;
    documentVersionId?: string;
    fileName?: string;
    name: string;
    entityTitle?: string;
    // Only sources that offer AI on the document know it; elsewhere it stays undefined.
    isTooLargeForAi?: boolean;
}

// localFile is a file that only exists in the browser so far, such as one uploaded for a contract that has not
// been created yet: there is no server url to fetch it from.
export type PreviewableDocument = BasePreviewableDocument &
    (
        | { customDocumentUrl: string; entityType?: never; entityId?: never; localFile?: never }
        | { customDocumentUrl?: never; entityType: EntityType; entityId: string; localFile?: never }
        | { customDocumentUrl?: never; entityType?: never; entityId?: never; localFile: Blob }
    );

export enum DocumentFileType {
    Pdf,
    Image,
    Word,
    Email,
    Unsupported,
}

export interface IDocumentData {
    blobUrl: string | null;
    arrayBuffer: ArrayBuffer | null;
    fileName: string;
    fileType: DocumentFileType;
}

export interface ExtractedTextResponse {
    content: string;
    pageOffsets: Array<number>;
}

export interface IDocumentNavigation {
    currentIndex: number;
    totalDocuments: number;
    onPreviousDocument: () => void;
    onNextDocument: () => void;
}

/**
 * An opt-in button in the toolbar's right-hand slot. It exists because the toolbar prop set is closed and
 * has no generic slot, so a feature that needs an action there has to be threaded through the viewers.
 */
export interface IDocumentPreviewToolbarAction {
    icon: ReactNode;
    tooltip: string;
    onClick: () => void;
    disabled?: boolean;
}
